import moment from "moment";
import { convertDateToString } from "../../Helpers/dateFunctions";

export const appointmentBook = {
  allergies: [],
  medications: [],
  aadhaarNumber: "",
  emergencyContactName: "",
  emergencyContactNumber: "",
  patientHospitalId: "",
  gender: "",
  patientName: "",
  isPatientNumberVerified: false,
  patientNumber: "",
  emailID: "",
  couponCode: null,
  specialisation: "",
  typeOfConsultation: "",
  chosendoctorId: "",
  chosenDoctorName: "",
  chosenDate: "",//convertDateToString(moment(new Date())),
  chosenTime: "",
  heightValue: "",
  heightMeasurement: "",
  weightValue: "",
  weightMeasurement: "",
  bmi: "",
  bloodGroup: "",
  bloodpressure: {
    systolic: "",
    diastolic: ""
  },
  bloodpressureMeasurement: "mmHG",
  bloodpressureMeasurementDate: "",//convertDateToString(moment(new Date())),
  bodytemprature: "",
  bodytempratureMeasurement: "",
  bodytempratureMeasurementDate: "",//convertDateToString(moment(new Date())),
  bodytempraturePosition: "",
  pulserate: {
    value: "",
    unit: "Beats/Min"
  },
  pulserateMeasurementDate: "",//convertDateToString(moment(new Date())),
  pulserateMeasurementPosition: "",
  Respiration: {
    value: "",
    unit: "Beats/Min"
  },
  lmp: "",
  RespirationMeasurementDate: "",//convertDateToString(moment(new Date())),
  patientLifeStyles: {
    alcohol: "",
    smoke: "",
    exercise: "",
    sleep: "",
    travel: ""
  },
  patientPreExistingConditions: {
    anemia: {
      condition: "",
      self: "",
      family: ""
    },
    asthma: {
      condition: "",
      self: "",
      family: ""
    },
    diabetes: {
      condition: "",
      self: "",
      family: ""
    },
    cholesterol: {
      condition: "",
      self: "",
      family: ""
    },
    thyroidDisease: {
      condition: "",
      self: "",
      family: ""
    },
    heartDisease: {
      condition: "",
      self: "",
      family: ""
    },
    stroke: {
      condition: "",
      self: "",
      family: ""
    },
    glaucoma: {
      condition: "",
      self: "",
      family: ""
    },
    highBloodPressure: {
      condition: "",
      self: "",
      family: ""
    },
    cancer: {
      condition: "",
      self: "",
      family: ""
    },
    tuberculosis: {
      condition: "",
      self: "",
      family: ""
    },
    allergies: {
      condition: "",
      self: "",
      family: ""
    }
  },
  reportsUploaded: [],
  reports: []
} 
